<template>
  <div class="container pt-3">
    <div class="row login">
      <div class="col-12 col-md-6">
        <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
        <div class="card card-style">
          <div class="card-body">
            <div class="card-title text-center almarai-bold">{{$t('login.title_1')}}</div>
            <form action="">
              <div class="row">
                <div class="col position-R">
                  <label class="text-style p-2">
                    {{$t('login.title_2')}}
                    <span class="stars">*</span>
                  </label>
                  <!-- <span class="phone-icon">
                    <i v-if="userLang == 'ar'" class="fa-solid fa-phone"></i>
                    <i v-else class="fa-solid fa-phone-flip"></i>
                  </span> -->
                  <input type="text" maxlength="10" v-model="mobile" @input="mobile = mobile.replace(/[^0-9]/g, '')"
                    class="form-control input-style inputPadding" :placeholder= "$t('login.title_3')" 
                  >
                  <img src="/assets/images/icons/mobile.png" class="max-20 mobile_Icon" alt="">
                </div>
                <div class="error-feedback red-color fonttext-14" v-if="V$.mobile.$error">
                  {{ validateMessage }}
                </div>
              </div>
              <div class="row">
                <div class="col position-R">
                  <label class="text-style p-2">
                    {{$t('login.title_4')}}
                    <span class="stars">*</span>
                  </label>
                  <!-- <i class="fa-regular fa-eye-slash"></i> -->
                  <input :type="fieldType" v-model="password" maxlength="50"
                    class="form-control phone-input" :placeholder="$t('login.title_5')"
                  >
                  <span v-if="fieldType == 'password'" @click.prevent="togglePassword" class="eyes-Icons">
                    <i class="fa-regular fa-eye-slash"></i>
                  </span>
                  <span v-else  @click.prevent="togglePassword" class="eyes-Icons">
                    <i class="fa-regular fa-eye"></i>
                  </span>
                  <!-- <ul v-show="showPasswordRules" class="password-rules mt-2 list-unstyled">
                    <li :class="{ 'text-success': passwordRules.length }">At least 8 characters long</li>
                    <li :class="{ 'text-success': passwordRules.uppercase }">Contains 1 uppercase character</li>
                    <li :class="{ 'text-success': passwordRules.numberOrSymbol }">Contains 1 number or symbol</li>
                  </ul> -->
                </div>
                <div class="error-feedback red-color fonttext-14" v-if="V$.password.$error">
                  {{ validateMessage }}
                </div>
              </div>
              <div class="row pt-3">
                <div class="col almarai-bold">
                  <router-link to="/forgetPassword">{{$t('login.title_6')}}</router-link>
                </div>
              </div>
              <div class="row pt-3 justify-content-center">
                <div class="col-11 col-md-6">
                  <div v-if="isLoading" class="text-center">
                    <loader />
                  </div>
                  <div v-else @click.prevent="loginFN" type="submit" class="btn-green form-control almarai-bold">{{$t('login.title_1')}}</div>
                </div>
              </div>
              <div class="row pt-3 justify-content-center">
                <div class="col-11 col-md-6 text-center">
                  <span class="textAccount"> ـــــــــــــــــ {{$t('login.title_7')}} ـــــــــــــــــ  </span>
                </div>
              </div>
              <div class="row pt-3 justify-content-center">
                <div class="col-11 col-md-6 text-center">
                  <router-link to="/register">
                    <div class="form-control btn-black">
                      {{$t('login.title_8')}}
                    </div>
                  </router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 d-none d-md-block hero">
        <div class="homeSearch">{{$t('perfectHome')}}</div>
        <div class="homeSearch">{{$t('easily')}}</div>
        <div class="realEstate_Offerings">{{$t('realEstate_Offerings')}}</div>
        <div class="row padding_px">
          <div class="col realEstate_platform">
            {{$t('realEstate_platform')}}
          </div>
          <div class="col-auto btnGreen_small mx-3">
            {{$t('certifiedAgents')}}
          </div>
          <div class="col-auto btnGreen_small">
            {{$t('dailyUpdates')}}
          </div>
          <div class="col-auto btnGreen_small mx-3">
            {{$t('overProperties')}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
export default {
  name: 'login',

  setup () {
    return { V$: useVuelidate() }
  },

  data(){
    return {
      hasError: false,
      message: "",
      errorNumber: 0,
      isLoading: false,
      mobile: "",
      password: "",
      fieldType: 'password',
      userLang: 'ar',
      validateMessage: this.$t('validateMessage'),
    }
  },

    validations(){
    return {
      mobile: {required},
      password: {required},
    }
  },

  methods:{
    async loginFN(){
      this.hasError = false;
      const valid = await this.V$.$validate();
      if(!valid){
        window.scrollTo({top:0, behavior:'smooth'});
        return false;
      }
      if(!this.mobile.startsWith('05') || this.mobile.trim().length != 10){
        this.message = this.$t('incorrectMobile');
        this.hasError = true;
        window.scrollTo({top:0, behavior:'smooth'});
        return false;
      }
      this.isLoading = true;
      this.$http.post("/api/auth/login",{
        mobile: this.mobile,
        password: this.password,
        platform: "website",
      }).then(res => {
        // console.log(res);
        this.$store.commit('SET_USER_DATA', res.data.user);
        window.location.href = '/';
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.message = this.$globalError(err);
        this.hasError = true;
        this.isLoading = false;
        window.scrollTo({top:0, behavior:'smooth'});
      })
    },

    togglePassword(){
      this.fieldType = this.fieldType === 'password' ? 'text' : 'password';
    },
    // checkPasswordRules() {
    //   this.showPasswordRules = true;
    //   this.passwordRules.length = this.password.length >= 8;
    //   this.passwordRules.uppercase = /[A-Z]/.test(this.password);
    //   this.passwordRules.numberOrSymbol = /[0-9!@#$%^&*]/.test(this.password);
    // },
  },
  created(){
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>